<script>
    // export let icon = '<i class="fas fa-ellipsis-v" />';
    export let icon = '<i class="fas fa-angle-down" />';
    export let stopPropagate = false;
    import { createEventDispatcher, afterUpdate } from "svelte";
    const dispatch = new createEventDispatcher();
    afterUpdate(() => {
        if(stopPropagate)
        jQuery(".dropdown-menu").click(function (e) {
            e.stopPropagation();
        });
    });
</script>

<div class="dropdown d-none d-sm-block">
    <!-- <a
        class="btn btn-grey rowMenu"
        href="#"
        style="top:3px;font-size:15px;position:relative;"
        on:click={() => dispatch('click')}
        role="button"
        id="dropdownMenuLink"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        {@html icon}
    </a> -->
    <a
        class="rowMenu"
        href="#"
        style="top:3px;font-size:15px;position:relative;"
        on:click={() => dispatch('click')}
        role="button"
        id="dropdownMenuLink"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        {@html icon}
    </a>
    <div
        class="dropdown-menu"
        aria-labelledby="dropdownMenuButton"
        style="padding:0px;border:0px;">
        <slot />
    </div>
</div>
<style>
   .dropdown-menu {
    transform: unset !important;
    margin-top:30px;
    margin-left: -40px;
    /* position: unset  !important; */
  }

</style>
